import React, { useState, useEffect } from "react";
import { Card, Popover } from "antd";
import {
  IoInformationCircle,
  IoSunnySharp,
  IoMoonSharp,
} from "react-icons/io5";
import ReactGA from "react-ga4";
import getProductName from "../../../utils/getProductName";
import categoryImage from "../../../constants/categoryIcons";
import NoImage from "./../../../assets/images/Image_not_available.png";

interface ProductCardInterface {
  data?: any;
  value?: any;
  isCurrentSkincare?: boolean;
  showIcons?: boolean;
}

const { Meta } = Card;

const ProductCard: React.FC<ProductCardInterface> = (props) => {
  const { data, value, showIcons, isCurrentSkincare } = props;

  const [open, setOpen] = useState(false);
  const isOldProduct = data?.user_product;
  const [productImage, setProductImage] = useState<any>(
    isOldProduct || showIcons
      ? categoryImage[
          data?.category?.name?.toLowerCase() ??
            data?.category?.toLowerCase() ??
            "other"
        ]
      : data?.image
  );
  let productName: any = getProductName(data?.name);

  useEffect(() => {
    setProductImage(
      isOldProduct || showIcons
        ? categoryImage[
            data?.category?.name?.toLowerCase() ??
              data?.category?.toLowerCase() ??
              "other"
          ]
        : data?.image
    );
  }, [data]);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (newOpen) {
      ReactGA.event({
        category: "Store",
        action: `Why don't use clicked`,
        label: "Current Skincare why don't use icon clicked",
        nonInteraction: true, // optional, true/false
        transport: "xhr",
      });
    }
    setOpen(newOpen);
  };

  return (
    <div
      className={`product ${isOldProduct || showIcons ? "remove-cursor" : ""}`}
    >
      {value === "Do Not Use" ? (
        <div className="popover-container">
          <img
            alt="Product_Image"
            src={productImage}
            className="product__image"
          />
          {/* <div className="donotUsePopover">
            <Popover
              open={open}
              onOpenChange={handleOpenChange}
              overlayClassName="doNotUsePopover"
              content={
                <>
                  <div className="popover-content">
                    {typeof data?.note === "object" ? (
                      <div>
                        {data?.note.map((n: any, i: number) => {
                          return (
                            <div className="donotUsePopover__list-item" key={i}>
                              {i == 0 ? <IoSunnySharp /> : <IoMoonSharp />}
                              <p>{n}</p>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      data?.note ?? <i>N/A</i>
                    )}
                  </div>
                  <div className="popover-close" onClick={hide}>
                    x
                  </div>
                </>
              }
              title={<h3>Why don't use this product?</h3>}
              trigger="click"
            >
              <div className="popover-container__clickable">
                <IoInformationCircle className="icon" color="#6489b1" />
              </div>
            </Popover>
          </div> */}
        </div>
      ) : productImage ? (
        <img
          alt="product_image"
          src={productImage}
          className="product__image"
        />
      ) : (
        <img
          alt="product_image"
          src={NoImage}
          className="product__no__image"
          style={{
            height: "100px !important",
            width: "100px !important",
          }}
        />
      )}
      <div className={`product__content`}>
        {(data?.brand_name || data?.category?.name) && (
          <div>
            <Meta title={data?.brand_name} className="product__title" />
          </div>
        )}
        <span className="product__category">
          {data?.name}
          {data?.frequency === "Can Skip"  && !isCurrentSkincare && (
            <p className="product__frequency">
              <i>({data?.frequency})</i>
            </p>
          )}
        </span>
      </div>
    </div>
  );
};

export default ProductCard;
